export default "__VITE_ASSET__CE0691UI__";